import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {environment} from "@environments/environment";
import {catchError, Observable, of, tap} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(private http: HttpClient,
              private router: Router,
  ) {

  }

  public login(username: string, password: string) {
    return this.http.post(environment.API.authURL, {username: username, password: password}).pipe(
      // @ts-ignore
      tap((token: any) => {
        if (token) {
          localStorage.setItem('COMIN_currentUser', JSON.stringify(token));
        }
      }));
  }

  refreshToken(T: any, failReturnUrl = '') {
    if (!T['refresh']) {
      return new Observable(subscriber => subscriber.error("No refresh token available"))
    }
    return this.http.post(environment.API.authRefreshURL, {refresh: T['refresh']}).pipe(
      tap((token: any) => {
        if (token) {
          if(token.access) {
            T['access'] = token.access;
          }
          if(token.refresh) {
            T['refresh'] = token.refresh;
          }
          localStorage.setItem('COMIN_currentUser', JSON.stringify(T));
          // console.log('token refresh successful');
        }
      }),
      catchError(() => {
        // console.log('token refresh fail');
        this.logout({returnUrl: failReturnUrl});
        return of(false); // Blocca l'accesso
      }));
  }

  public logout(queryParams: any = {}) {
    // remove user from local storage to log user out
    localStorage.removeItem('COMIN_currentUser');

    this.router.navigate(['/login'], {queryParams: queryParams});
  }
}
